import React from "react";
import TeamHero from "../../components/teamComponents/teamHero/TeamHero";
import TeamSection from "../../components/teamComponents/teamSection/TeamSection";

const OurTeam = () => {
  return (
    <div>
      <TeamHero />
      <TeamSection />
    </div>
  );
};

export default OurTeam;
